import { Models } from './core';
import { range, readOnly } from './restutil';
export class PackagingProduct {
  public static ApiUrl = 'api/packagingproduct';
  @range(null, 100)
  Name: string;

  ApprovedForNs9415: boolean;

  ProductId?: number;
  Product: Models.Product;

  Id: number;
  Created?: Date;
  Updated?: Date;

  @readOnly()
  IsDeleted: boolean;
}

export class CheckDuplicatePackagingProduct {
  Id?: number;
  ProductId: number;
}
